import React, {useState} from "react"
import "./Partner.css"
import banner from "../../src/media/partnerreg.jpg"
import ReCAPTCHA from "react-google-recaptcha";
import emailjs from "emailjs-com"

export default function Partner () {
    const [captcha,setCaptcha] = useState(false)
    function captchaDone () {
        const but = document.getElementById("partnerSend")
        const checkbox = document.getElementById("terms")
        setCaptcha(true)
        if(checkbox.checked) {
            but.className = "activeSend"
        }
    }
    const submit = (e) => {
        const checkbox = document.getElementById("terms")
        e.preventDefault();
        if(checkbox.checked && captcha) {
            const inputs = [...document.querySelectorAll("input")]
            let normal = true
            inputs.forEach((el) => {
                if(el.value === "") {
                    normal = false
                    el.className += " error"
                }
                else {
                    if(el.id !== "terms") {el.className = ""}
                }
                document.getElementById("partnerSend").className = "contactInput"
            })
            if(!normal) {
                document.getElementById("terms").checked = false
                return
            }
            // emailjs.sendForm('service_85keurj', 'template_1z8a80n', e.target, 'user_I9RkM2wjvwskcN9ZDoUS0')
            // .then((result) => {
            //     document.getElementById("partnerSend").value = "Sent!"
            //     e.target.reset()
            //     document.getElementById("terms").checked = false
            // }, (error) => {
            //     console.log(error.text);
            // });
            const gender = document.getElementsByName("gender")[0].value
            const name = document.getElementsByName("name")[0].value
            const surname = document.getElementsByName("surname")[0].value
            const func = document.getElementsByName("func")[0].value
            const company = document.getElementsByName("company")[0].value
            const phone = document.getElementsByName("phone")[0].value
            const location = document.getElementsByName("location")[0].value
            const postal = document.getElementsByName("postal")[0].value
            const street = document.getElementsByName("street")[0].value
            const message = document.getElementsByName("message")[0].value
            const email = document.getElementsByName("email")[0].value
            const but = document.getElementById("partnerSend")
            but.value = "Loading..."
            window.Email.send({
                SecureToken : "3b00537d-65cc-40a2-a91e-eb8b46f5ee8e ",
                To : 'info@xfusion.shop',
                From : "dev.vladbrown@gmail.com",
                Subject : `New Partner request `,
                Body : ` Gender: ${gender}

                         Name: ${name}
                        
                         Surname: ${surname}
                        
                         Function: ${func}

                         Email: ${email}

                         Street: ${street}

                         Message: ${message}
                        
                         Company: ${company}
                        
                         Phone: ${phone}
                        
                         Location: ${location}
                        
                         Postal: ${postal}`
            }).then((message) => {
               e.target.reset()
               but.value = "Message Sent!"
               but.className += " succesfulBut"
            });
        }

        
        
    };
    function checkbox (e) {
        const but = document.getElementById("partnerSend")
        if(e.target.checked && captcha) {but.className = "activeSend"}
        if(!e.target.checked) {but.className = ""}
    }
    return (
        <>
            <img className="banners" src={banner} alt="" />
            <section id="partnerSec">
                <h1>Absolut xFusion Partner registration</h1>
                <form onSubmit={submit} id="partnerForm" action="">
                    <div className="formColumn">
                    <select name="gender">
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                    </select>
                        <input name="name" placeholder="Name" type="text" />
                        <input name="surname" placeholder="Surname" type="text" />
                    </div>
                    <div className="formColumn">
                        <input name="location" placeholder="Location" type="text" />
                        <input name="postal" placeholder="Postal Code" type="text" />
                        <input name="street" placeholder="Street" type="text" />
                    </div>
                    <div className="formColumn">
                        <input name="func" placeholder="Function" type="text" />
                        <input name="company" placeholder="Company" type="text" />
                        <input name="phone" placeholder="Mobile phone" type="tel" />
                    </div>
                    <div className="formColumn">
                        <input name="email" placeholder="Email" type="email" />
                        <input name="message" placeholder="Message" type="text" />
                        <input type="submit" id="partnerSend" value="Send" />
                    </div>
                </form>
                <div id="termsWrapper">
                    <div>
                        <input onChange={checkbox} type="checkbox" id="terms" name="scales"/>
                        <label for="terms">I agree that my details from the contact form will be collected and processed to answer my request in accordance with the data protection declaration.</label>
                    </div>
                </div>
                <ReCAPTCHA
                    sitekey="6LdPbH8fAAAAAF7ITOGQ30RMJWrYL50UR06fE9-F"
                    onChange={captchaDone}
                />,
            </section>
        </>
    )
}